import { useState, useEffect, forwardRef, useMemo, useRef } from "react";
import {
  Link,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import axios from "axios";
import BASE_URL from "../../../assets/global/url";
import swal from "sweetalert";
import { validateCheckNumbers } from "../../../utils/checkNumberValidator";
import CheckNumberError from "../../../components/inputs/CheckNumberError";
import { checkCutoffDate } from "../../../utils/cutoffDateValidation";
import Select from "react-select";
import { selectCustomStyles } from "../../../assets/global/selectCustomStyles";
import useDarkMode from "../../../components/Themes/Usedarkmode";
import {
  formatCurrency,
  formatToPHP,
  formatToTwoDecimal,
  parseNumber,
} from "../../../utils/numberFormatter";
import { Table, Modal, Button, Form, Card } from "react-bootstrap";
import { Line } from "react-chartjs-2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import useDecodeToken from "../../../hooks/customHook/useDecodeToken";
import { format } from "date-fns";
import { useServerPagination } from "../../../hooks/customHook/paginationHook/useServerPagination";
import { PaginationControls } from "../../../hooks/customHook/paginationHook/usePagination";
import { useSort } from "../../../hooks/customHook/tableSort";
import CustomDatePicker from "../../../components/CustomDatePicker";
import TypedDateInput from "../../../components/inputs/TypedDateInput";
import FilterStore from "../../../hooks/customHook/FilterStore";
import { AccountHistoryView } from "../components/ViewAccountList/AccountHistoryView";
import AccountSummaryExportModal from "../components/ViewAccountList/AccountSummaryExportModal";

import JournalizedBalance from "../components/ViewAccountList/journalizedAmount";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
);

const ViewAccountlist1 = ({ authrztn = [] }) => {
  // State for dropdown selections
  const [subject1, setSubject1] = useState("");
  const [subject2DataList, setSubject2DataList] = useState([]);
  const [subject2, setSubject2] = useState("");
  const [subject2Type, setSubject2Type] = useState("");
  const [subject3DataList, setSubject3DataList] = useState([]);
  const [subject3, setSubject3] = useState("");
  const [paymentMethod, setPaymentMethod] = useState();
  const [amount, setAmount] = useState("");
  const [checkNo, setCheckNo] = useState("");
  const [remarks, setRemarks] = useState("");
  const [maturityCheckNo, setMaturityCheckNo] = useState("");
  const [processDate, setProcessDate] = useState("");
  const [date, setDate] = useState("");
  const [creditDateError, setCreditDateError] = useState("");
  // State to manage disabled states
  const [isSubject1Disabled, setIsSubject1Disabled] = useState(true);
  const [isSubject2Disabled, setIsSubject2Disabled] = useState(true);
  const [isSubject3Disabled, setIsSubject3Disabled] = useState(true);
  const [isPaymentMethodDisabled, setIsPaymentMethodDisabled] = useState(true);
  const [isRemarksDisabled, setIsRemarksDisabled] = useState(true);
  const [isSelectedCurrencyDisabled, setIsSelectedCurrencyDisabled] =
    useState(true);
  const [showModal, setShowModal] = useState(false);
  const [showModal2, setShowModal2] = useState(false);

  const [otherCurrency, setOtherCurrency] = useState(false);
  const [currencyList, setCurrencyList] = useState([]);
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedCurrencyName, setSelectedCurrencyName] = useState("");
  const [originalRate, setOriginalRate] = useState("");

  const [currencyRate, setCurrencyRate] = useState("");
  const [payModal, setPayModal] = useState(false);
  const [payDateError, setPayDateError] = useState("");
  const [isPaySubmitting, setIsPaySubmitting] = useState(false);
  // Ref guard blocks rapid double clicks before the state update re-renders the button
  const paySubmittingRef = useRef(false);
  // Same guard for Transfer Money / Transfer Money to Other Currency
  const [isTransferSubmitting, setIsTransferSubmitting] = useState(false);
  const transferSubmittingRef = useRef(false);

  const [selectedPaymentPay, setSelectedPaymentPay] = useState("");
  const [transferPaymentMethod, setTransferPaymentMethod] = useState(""); // Bank or Cash for Transfer Money modal

  const [searchParams, setSearchParams] = useSearchParams();

  const [showViewModal, setShowViewModal] = useState(false);
  const [selectedTransactionId, setSelectedTransactionId] = useState(null);

  // Export preview: "pdf" | "excel" | null (closed)
  const [exportType, setExportType] = useState(null);

  const handleShow = () => setShowModal(true);
  const handleShow2 = (type) => {
    setOtherCurrency(type === "Normal" ? false : true);
    setProcessDate(new Date());
    // Capture the full-precision balance before the modal opens so we can
    // send the unrounded value to the backend even though the UI shows 5.67
    setRawAmount(accountName?.amount != null ? String(accountName.amount) : "");
    setShowModal2(true);
  };

  const handleShowPayModal = () => setPayModal(true);
  const handleClosePayModal = () => {
    setPayModal(false);
    setPayDateError("");
  };

  // Returns an error message if the date is outside any cutoff or inside a posted cutoff, otherwise ""
  const getCutoffDateError = async (selectedDate) => {
    const formattedDate = format(new Date(selectedDate), "yyyy-MM-dd");

    const { data: isInCutoff } = await axios.get(
      `${BASE_URL}/cutoff/dateValidation`,
      { params: { date: formattedDate } },
    );
    if (!isInCutoff) {
      return "The selected date does not fall within any cutoff period. Please choose a valid date.";
    }

    const { data: isPosted } = await axios.get(
      `${BASE_URL}/cutoff/validation/posted-cutoff`,
      { params: { date: formattedDate } },
    );
    if (isPosted) {
      return "The selected date falls within a posted cutoff period. Please choose a date in an unposted cutoff.";
    }

    return "";
  };

  const userLoggedID = useDecodeToken();
  const { themeSelectStyles } = useDarkMode();
  // react-select colors come from JS, so wrap them for dark mode
  const dmSelectStyles = (...args) =>
    themeSelectStyles(selectCustomStyles(...args));
  const onInputFloat = (e) => {
    e.target.value = e.target.value.replace(/[^0-9.]/g, "");
  };

  const { id } = useParams();
  const location = useLocation();

  const fromAccList = location.state ? location.state.accList : false;
  const fromLiability = location.state ? location.state.liability : false;
  const isFromAssetAccount =
    location.pathname.includes("view-assetAccount") ||
    location.pathname.includes("view-accountlist");

  const [accountName, setAccountName] = useState([]);
  const [validated, setValidated] = useState(false);
  const [totalAmountGraph, setTotalAmountGraph] = useState(0);
  const [balanceAmount, setBalanceAmount] = useState("");
  const [createdAt, setCreatedAt] = useState("");

  const [receivedRateList, setReceivedRateList] = useState([]);
  const [receivedCurrencyRate, setReceivedCurrencyRate] = useState(""); // Rate for transferring money to other currency
  const [rate, setRate] = useState(""); // Rate for transferring money to same currency
  const [rawAmount, setRawAmount] = useState(""); // full-precision balance from DB — avoids rounding on transfer submit

  const handleClose = () => {
    setShowModal(false);
    setShowModal2(false);
    setValidated(false);
    setSubject1("");
    setSubject2("");
    setSubject3("");
    setPaymentMethod(paymentMethodDefaultValue);
    setAmount("");
    setCheckNo("");
    setMaturityCheckNo("");
    setProcessDate("");
    setDate("");
    setCreditDateError("");
    setIsSubject2Disabled(true);
    setIsSubject3Disabled(true);
    setIsPaymentMethodDisabled(true);
    setIsRemarksDisabled(true);
    setSelectedCurrency("");
    setReceivedCurrencyRate("");
    setTransferPaymentMethod("");
    setRawAmount("");
  };

  const [graphBalance, setGraphBalance] = useState([]);
  const pagination = useServerPagination(
    BASE_URL + "/accountListSub/getTransaction",
    10,
    {
      id: id,
      sortType: "desc",
      sortDBTableColumn: "date",
    },
  );

  const reloadTable = () => {
    pagination.updateParams({
      id: id,
      sortType: "desc",
      sortDBTableColumn: "date",
    });
    // axios
    //   .get(`${BASE_URL}/accountListSub/getTransaction`, {
    //     params: {
    //       id: id,
    //     },
    //   })
    //   .then((res) => {
    //     setTransaction(res.data);
    //     setFilteredTransactions(res.data);
    //   })
    //   .catch((error) => {
    //     console.error("Error fetching transactions:", error);
    //   });
  };

  const reloadCurrency = () => {
    axios.get(BASE_URL + "/currency/fetchCurrency").then((res) => {
      setCurrencyList(res.data);
    });
  };

  const Balance = () => {
    axios
      .get(`${BASE_URL}/accountListSub/getBalance`, {
        params: {
          id: id,
        },
      })
      .then((res) => {
        const balanceData = res.data.data; // Assuming res.data contains an array of { date, amount }
        const totalAmount = res.data.totalAmount;
        setTotalAmountGraph(totalAmount);

        const currentMonth = new Date().getMonth(); // 0 = Jan, 3 = Apr, etc.
        const monthlyData = Array(12).fill(null);

        // Last-write-wins per month: since data is sorted ASC by createdAt,
        // later entries overwrite earlier ones, leaving the final balance for that month.
        balanceData.forEach((balance) => {
          if (balance.account_balance == null) return;
          const month = new Date(balance.createdAt).getMonth();
          if (month <= currentMonth) {
            monthlyData[month] = balance.account_balance;
          }
        });

        // Forward-fill: months with no transactions inherit the previous month's balance
        // (the account still exists and its balance hasn't changed).
        let lastKnownBalance = null;
        for (let i = 0; i <= currentMonth; i++) {
          if (monthlyData[i] !== null) {
            lastKnownBalance = monthlyData[i];
          } else if (lastKnownBalance !== null) {
            monthlyData[i] = lastKnownBalance;
          }
        }

        console.log("Monthly balance data (createdAt-based):", monthlyData);

        // Update the chartData state with the accumulated monthly amounts
        setChartData((prevState) => ({
          ...prevState,
          datasets: [
            {
              ...prevState.datasets[0],
              data: monthlyData, // Set the processed monthly data to the chart
            },
          ],
        }));
      })
      .catch((error) => {
        console.error("Error fetching balance:", error);
      });
  };
  const [module_type, setModule_type] = useState("");

  const reloadAccountName = () => {
    axios
      .get(`${BASE_URL}/accountListSub/accountName/`, {
        params: {
          id: id,
        },
      })
      .then((res) => {
        setAccountName(res.data);
        setModule_type(res.data?.account_list_base_sub?.module_type);
        getSubject3ReceivedRate(res.data.id);
      });
  };

  const getSubject3ReceivedRate = async (id) => {
    try {
      const res = await axios.get(`${BASE_URL}/accountListSub/received-rate`, {
        params: {
          id,
        },
      });

      setReceivedRateList(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  const addAllFilterOptions = (options) => {
    const optionAll = {
      label: "All",
      value: "all",
    };

    return [optionAll, ...options];
  };

  const receivedRateOptions = receivedRateList.map((item) => ({
    label: item.rate,
    value: item.rate,
  }));

  useEffect(() => {
    setFilteredTransactions(pagination.data);
    //console.log(`paginationsssssss.data`, pagination.data);
    // setTransaction(pagination.data);
  }, [pagination.data]);

  useEffect(() => {
    Balance();
    reloadAccountName();
    reloadCurrency();

    const savedDates = FilterStore.AL1getDate();

    if (savedDates?.from && savedDates?.to) {
      // Has saved dates — apply filter immediately, no button click needed
      pagination.updateParams({
        id: id,
        startDate: new Date(savedDates.from).toLocaleDateString(),
        endDate: new Date(savedDates.to).toLocaleDateString(),
        sortType: "desc",
        sortDBTableColumn: "date",
      });
    } else {
      // No saved dates — load normally without date filter
      reloadTable();
    }
  }, []);

  const [chartData, setChartData] = useState({
    labels: [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ],
    datasets: [
      {
        label: "Net Balance",
        borderColor: "rgb(178, 161, 255)",
        backgroundColor: "rgba(178, 161, 255, 0.3)",
        tension: 0.4,
        fill: true,
        pointRadius: 3,
        pointHoverRadius: 5,
      },
    ],
  });

  const chartOptions = {
    responsive: true,
    plugins: {
      legend: { display: false },
    },
    scales: {
      y: {
        beginAtZero: false,
        suggestedMin: 0,
        suggestedMax: totalAmountGraph * 1.1,
        ticks: {
          callback: (value) => formatToPHP(value),
        },
      },
    },
    elements: {
      line: {
        borderWidth: 2,
      },
      point: {
        radius: 0,
      },
    },
  };

  // Update subject2 and subject3 based on Subject 1 selection
  const handleSubject1Change = (selectedOption) => {
    const selectedSubject1 = selectedOption.value;
    let account_selected = "";

    if (selectedSubject1 === "Account-List") {
      account_selected = "Account-List";
    } else if (selectedSubject1 === "Asset Account") {
      account_selected = "Asset Account";
    } else if (selectedSubject1 === "Liabilities Account") {
      account_selected = "Liabilities Account";
    } else if (selectedSubject1 === "Owner's Equity Account") {
      account_selected = "Owner's Equity Account";
    }

    try {
      if (fromLiability || payModal) {
        axios
          .get(`${BASE_URL}/accountListSub/getSubjectToPay`, {
            params: {
              account_selected: account_selected,
              currency_id: selectedCurrency?.value,
              selectedPayment: selectedPaymentPay,
            },
          })
          .then((res) => {
            setSubject1(selectedOption);

            setSubject2("");
            setSubject3("");
            setPaymentMethod(paymentMethodDefaultValue);
            setIsSubject2Disabled(otherCurrency ? true : false);

            setIsSubject3Disabled(true);
            setIsPaymentMethodDisabled(true);
            setIsRemarksDisabled(true);

            setSubject2DataList(res.data);
            setIsSubject2Disabled(false);
            console.log(res.data);
          });
      } else {
        axios
          .get(`${BASE_URL}/accountListSub/getSubjectWithSpecificCurrency`, {
            params: {
              account_selected: account_selected,
              currency_id: selectedCurrency?.value,
            },
          })
          .then((res) => {
            setSubject1(selectedOption);

            setSubject2("");
            setSubject3("");
            setPaymentMethod(paymentMethodDefaultValue);
            setIsSubject2Disabled(otherCurrency ? true : false); // Enable Subject 2 after Subject 1 selection
            // setIsSelectedCurrencyDisabled(false);
            setIsSubject3Disabled(true); // Reset and disable Subject 3
            setIsPaymentMethodDisabled(true); // Reset and disable Payment Method
            setIsRemarksDisabled(true); // Reset and disable Remarks/Check No.

            setSubject2DataList(res.data); //retrieve subject 2 data
            setIsSubject2Disabled(false); // Enable Subject 2 after Subject 1 selection
            console.log(res.data);
          });
      }
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  // Update Subject 3 based on Subject 2 selection
  const handleSubject2Change = (selectedOption) => {
    const subject_type = selectedOption?.subject_type;
    const selectedSubject2 = selectedOption?.value;
    setSubject3DataList([]);
    try {
      if (otherCurrency) {
        axios
          .get(
            `${BASE_URL}/accountListSub/getSubject3ChainDropdownWithCurrency`,
            {
              params: {
                subjectId: selectedSubject2,
                id: id,
                selectedCurrency: selectedCurrency?.value,
              },
            },
          )
          .then((res) => {
            console.log("DATA WITH CURR", res.data);
            setSubject3DataList(res.data);
            setSubject2(selectedOption);
            setSubject3("");
            setPaymentMethod(paymentMethodDefaultValue);
            setIsSubject3Disabled(false); // Enable Subject 3 after Subject 2 selection
            setIsPaymentMethodDisabled(true); // Reset and disable Payment Method
            setIsRemarksDisabled(true); // Reset and disable Remarks/Check No.

            setSubject2Type(subject_type);
          });
      } else {
        axios
          .get(`${BASE_URL}/accountListSub/getSubject3ChainDropdown`, {
            params: {
              subjectId: selectedSubject2,
              id: id,
            },
          })
          .then((res) => {
            setSubject3DataList(res.data);
            setSubject2(selectedOption);
            setSubject3("");
            setPaymentMethod(paymentMethodDefaultValue);
            setIsSubject3Disabled(false); // Enable Subject 3 after Subject 2 selection
            setIsPaymentMethodDisabled(true); // Reset and disable Payment Method
            setIsRemarksDisabled(true); // Reset and disable Remarks/Check No.
            setSubject2Type(subject_type);
          });
      }
    } catch (error) {
      console.log(error);
      swal({
        title: "Something went wrong",
        text: "Please contact your support immediately",
        icon: "error",
      });
    }
  };

  // Enable payment method after Subject 3 selection
  const handleSubject3Change = (selectedOption) => {
    const selectedSubject3 = selectedOption;
    setSubject3(selectedSubject3);
    setPaymentMethod(paymentMethodDefaultValue);
    setIsPaymentMethodDisabled(false); // Enable Payment Method after Subject 3 selection
    setIsRemarksDisabled(false);

    // if (fromLiability) {
    //   setIsRemarksDisabled(false); // Reset and disable Remarks/Check No.
    // } else {
    //   setIsRemarksDisabled(true);
    // }
  };

  // Enable Remarks/Check No. after Payment Method selection
  const handlePaymentMethodChange = (selectedOption) => {
    // const selectedPaymentMethod = event.target.value;
    setPaymentMethod(selectedOption);
    setIsRemarksDisabled(false); // Enable Remarks/Check No. after Payment Method selection
    setCheckNo("");
  };

  const handleCurrencyChange = (selectedOption) => {
    try {
      const id = selectedOption.value;
      const currData = currencyList.find((curr) => curr.id === id);
      if (accountName?.currency?.currency_name === "PHP") {
        setCurrencyRate(currData.currency_rate);
        // setReceivedCurrencyRate(currData.currency_rate);
        setOriginalRate(currData.currency_rate);
      } else {
        const currData = currencyList.find(
          (curr) =>
            curr?.currency_name === accountName?.currency?.currency_name,
        );
        setCurrencyRate(currData.currency_rate);
        // setReceivedCurrencyRate(currData.currency_rate);
        setOriginalRate(currData.currency_rate);
      }
      setSelectedCurrency(selectedOption);
      setSelectedCurrencyName(currData.currency_name);

      // Reset subjects so stale selections from a previous currency are cleared
      setSubject1("");
      setSubject2("");
      setSubject3("");
      setSubject2DataList([]);
      setSubject3DataList([]);
      setIsSubject1Disabled(false);
      setIsSubject2Disabled(true);
      setIsSubject3Disabled(true);
      setIsPaymentMethodDisabled(true); // Reset and disable Payment Method
      setIsRemarksDisabled(true); // Reset and disable Remarks/Check No.
    } catch (error) {
      console.error(error);
    }
  };

  //function for create transaction
  const handleFormSubmit = async (e, type) => {
    e.preventDefault();
    if (transferSubmittingRef.current) return;
    const form = e.currentTarget;

    const formatAmount = parseNumber(amount);

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
      swal({
        icon: "error",
        title: "Required Fields",
        text: "Please fill in all required fields.",
      });
    } else if (!fromLiability && !payModal && !transferPaymentMethod) {
      swal({
        icon: "error",
        title: "Required Fields",
        text: "Please select a payment method (Bank or Cash).",
      });
    } else if (type === "Credit" && creditDateError) {
      swal({
        icon: "error",
        title: "Invalid Date",
        text: creditDateError,
      });
    } else if (
      type === "Credit" &&
      transferPaymentMethod === "Cash" &&
      !processDate
    ) {
      swal({
        icon: "error",
        title: "Required Fields",
        text: "Please select a Process Date before submitting.",
      });
    } else if (formatAmount === "0") {
      swal({
        icon: "error",
        title: "Required Fields",
        text: "Amount And Date",
      });
    } else {
      transferSubmittingRef.current = true;
      setIsTransferSubmitting(true);
      try {
        if (type === "Credit" && processDate) {
          const formattedDate = format(new Date(processDate), "yyyy-MM-dd");

          const { data: isInCutoff } = await axios.get(
            `${BASE_URL}/cutoff/dateValidation`,
            { params: { date: formattedDate } },
          );

          if (!isInCutoff) {
            const msg =
              "The selected date does not fall within any cutoff period. Please choose a valid date.";
            setCreditDateError(msg);
            swal({ icon: "error", title: "Invalid Date", text: msg });
            return;
          }

          const { data: isPosted } = await axios.get(
            `${BASE_URL}/cutoff/validation/posted-cutoff`,
            { params: { date: formattedDate } },
          );

          if (isPosted) {
            const msg =
              "The selected date falls within a posted cutoff period. Please choose a date in an unposted cutoff.";
            setCreditDateError(msg);
            swal({ icon: "error", title: "Invalid Date", text: msg });
            return;
          }
        }

        if (
          transferPaymentMethod !== "Cash" &&
          checkNo &&
          !(await validateCheckNumbers(checkNo))
        )
          return;

        const willProceed = await swal({
          title: "Are you sure?",
          text: "Once submitted, you will not be able to edit this transaction.",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        });
        //Para sa activity log malaman kung saan nag create ng transaction kung Owner Equity ba or Accounting List kasi iisang route lang meron
        const currentLocation = location.pathname.includes("view-equityAccount")
          ? "Owner's Equity"
          : location.pathname.includes("view-liabilityAccount")
            ? "Asset Account"
            : "Accounting List";

        if (willProceed) {
          let response;

          if (otherCurrency) {
            const amountToSend = handleCalculateConversion(
              currencyRate,
              formatAmount,
            );
            response = await axios.post(
              // `${BASE_URL}/accountListSub/createTransactionToOtherCurrency`,
              `${BASE_URL}/accountListSub/v2/createTransactionToOtherCurrency`,
              {
                subject1: subject1?.value,
                subject3: subject3?.value,
                paymentMethod: transferPaymentMethod || paymentMethod?.value,
                amount: parseFloat(amountToSend),
                amountToDeduct: formatAmount,
                checkNo,
                remarks,
                date:
                  transferPaymentMethod === "Cash" ? processDate || date : date,
                id,
                type,
                module_from: module_type,
                userLoggedID,
                currentLocation,
                currencyRate,
                ...(processDate && { processDate }),
                receivedCurrencyRate:
                  accountName.currency.currency_name === "PHP"
                    ? "0"
                    : receivedCurrencyRate?.value,
                originalRate,
                currentCurrencyAmount: formatAmount,
                from_currency_name: accountName?.currency?.currency_name,
                to_currency_name: selectedCurrencyName,
              },
            );
          } else {
            const isPhp = accountName?.currency?.currency_name === "PHP";
            const currencyRate = isPhp
              ? accountName?.currency?.currency_rate
              : parseFloat(rate);

            response = await axios.post(
              // `${BASE_URL}/accountListSub/createTransaction`,
              `${BASE_URL}/accountListSub/v2/createTransaction`,
              {
                subject1: subject1?.value,
                subject3: subject3?.value,
                paymentMethod: transferPaymentMethod || paymentMethod?.value,
                amount: formatAmount,
                checkNo,
                remarks,
                date:
                  transferPaymentMethod === "Cash" ? processDate || date : date,
                id,
                type,
                module_from: module_type,
                userLoggedID,
                currentLocation,
                currencyRate,
                ...(processDate && { processDate }),
              },
            );
          }

          if (response.status === 200) {
            const activeMethod = transferPaymentMethod || paymentMethod?.value;
            const hasCheck = Boolean(checkNo && checkNo.trim() !== "");

            let swalText = "";

            if (activeMethod === "Cash") {
              swalText =
                "The transfer is pending. Go to the Cash Flow module then Confirmation tab to confirm and complete the transfer.";
            } else if (activeMethod === "Bank" && !hasCheck) {
              swalText =
                "The transfer is pending. Go to the Bank Transaction module then Pending tab to confirm and complete the transfer.";
            } else if (activeMethod === "Bank" && hasCheck) {
              swalText =
                "The transfer is pending. Go to the Receivable Check module then Pending tab to confirm and complete the transfer.";
            } else {
              swalText =
                "The transfer is pending. Please proceed to the respective module's pending tab to confirm and complete it.";
            }

            swal({
              icon: "success",
              title: "Transfer Recorded - Pending Confirmation",
              text: swalText,
            }).then(() => {
              handleClose();
              reloadTable();
              reloadAccountName();
              Balance();
            });
          } else {
            swal({
              icon: "error",
              title: "Something went wrong",
              text: "Please contact your support immediately",
              timer: 2000,
            });
          }
        }
      } catch (error) {
        console.error(error);
        swal({
          icon: "error",
          title: "Something went wrong",
          text: "Please contact your support immediately",
          timer: 2000,
        });
      } finally {
        transferSubmittingRef.current = false;
        setIsTransferSubmitting(false);
      }
    }
  };

  const handlePayLiability = async (e) => {
    e.preventDefault();
    if (paySubmittingRef.current) return;
    const form = e.currentTarget;

    let formatAmount = String(amount).replace(/,/g, "");

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
      swal({
        icon: "error",
        title: "Required Fields",
        text: "Please fill in all required fields.",
      });
    } else if (formatAmount === "0") {
      swal({
        icon: "error",
        title: "Required Fields",
        text: "Amount and Date",
      });
      return;
    } else if (
      subject3 &&
      parseFloat(formatAmount) > parseFloat(subject3.amount ?? 0)
    ) {
      swal({
        icon: "error",
        title: "Insufficient Balance",
        text: `The amount exceeds the available balance of the selected account (${formatToTwoDecimal(subject3?.amount)}).`,
      });
      return;
    } else {
      paySubmittingRef.current = true;
      setIsPaySubmitting(true);
      try {
        // Re-check on submit so a posted cutoff can never push through
        const cutoffError = await getCutoffDateError(date);
        if (cutoffError) {
          setPayDateError(cutoffError);
          swal({ icon: "error", title: "Invalid Date", text: cutoffError });
          return;
        }

        const willProceed = await swal({
          title: "Are you sure?",
          text: "Once submitted, you will not be able to edit this transaction.",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        });
        //Para sa activity log malaman kung saan nag create ng transaction kung Owner Equity ba or Accounting List kasi iisang route lang meron
        const currentLocation = location.pathname.includes("view-equityAccount")
          ? "Owner's Equity"
          : location.pathname.includes("view-liabilityAccount")
            ? "Liability"
            : location.pathname.includes("view-assetAccount") ||
                location.pathname.includes("view-accountlist")
              ? "Asset Account"
              : "Accounting List";

        if (willProceed) {
          const response = await axios.post(
            `${BASE_URL}/accountListSub/createTransactionLiability`,
            {
              subject1: subject1?.value,
              subject3: subject3?.value,
              paymentMethod: selectedPaymentPay,
              amount: parseFloat(formatAmount),
              // Bank → maturityCheckNo becomes the check number for issued_check/receivable checks
              // Cash → no check number needed (direct transfer)
              checkNo: selectedPaymentPay === "Bank" ? checkNo : "",
              date,
              id,
              module_from: module_type,
              userLoggedID,
              currentLocation,
              currencyName: accountName?.currency?.currency_name,
              currencyRate: accountName?.currency?.currency_rate,
            },
          );

          if (response.status === 200) {
            swal({
              icon: "success",
              title: "Transaction created successfully",
              timer: 2000,
            }).then(() => {
              handleClose();
              reloadTable();
              reloadAccountName();
              Balance();
              handleClosePayModal();
            });
          } else {
            swal({
              icon: "error",
              title: "Something went wrong",
              text: "Please contact your support immediately",
              timer: 2000,
            });
          }
        }
      } catch (error) {
        console.error(error);
        if (error.response?.status === 400) {
          swal({
            icon: "error",
            title: "Invalid Date",
            text: error.response.data?.message,
          });
        } else {
          swal({
            icon: "error",
            title: "Something went wrong",
            text: "Please contact your support immediately",
            timer: 2000,
          });
        }
      } finally {
        paySubmittingRef.current = false;
        setIsPaySubmitting(false);
      }
    }
  };

  const [fromDate, setFromDate] = useState(
    () => FilterStore.AL1getDate()?.from || "",
  );
  const [toDate, setToDate] = useState(
    () => FilterStore.AL1getDate()?.to || "",
  );
  const [filteredTransactions, setFilteredTransactions] = useState([]);

  // FilterStore is saved explicitly in applyFilter and cleared in clearFilter.
  // Removed auto-save on date change to prevent partial/stale dates being persisted.

  const applyFilter = () => {
    FilterStore.AL1saveDate(fromDate, toDate);
    pagination.updateParams({
      id: id,
      ...(fromDate &&
        toDate && {
          startDate: new Date(fromDate).toLocaleDateString(),
          endDate: new Date(toDate).toLocaleDateString(),
        }),
      sortType: "desc",
      sortDBTableColumn: "date",
      page: 1,
    });
    // if (fromDate && toDate) {
    //   const filtered = transaction.filter((t) => {
    //     const transactionDate = new Date(t.date);
    //     const from = new Date(fromDate);
    //     const to = new Date(toDate);

    //     // Check if transaction date is within the selected date range
    //     return transactionDate >= from && transactionDate <= to;
    //   });
    //   setFilteredTransactions(filtered);
    // } else {
    //   setFilteredTransactions(transaction); // Show all if no filter applied
    // }
  };

  const clearFilter = () => {
    setFromDate("");
    setToDate("");
    FilterStore.AL1saveDate("", "");

    pagination.updateParams({
      id: id,
      sortType: "desc",
      sortDBTableColumn: "date",
      startDate: undefined,
      endDate: undefined,
      page: 1,
    });
  };

  const [dateOtherIncome, setDateOtherIncome] = useState("");
  const [descriptionOtherIncome, setDescriptionOtherIncome] = useState("");
  const [amountOtherIncome, setAmountOtherIncome] = useState("");
  //Owners Equity Account
  const handleOtherIncomeSubmit = async (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      setValidated(true);
      swal({
        icon: "error",
        title: "Required Fields",
        text: "Please fill in all required fields.",
      });
    } else {
      try {
        const willProceed = await swal({
          title: "Add Other Income?",
          text: "Once submitted, you will not be able to edit this transaction.",
          icon: "warning",
          buttons: true,
          dangerMode: true,
        });

        if (willProceed) {
          const response = await axios.post(
            `${BASE_URL}/accountListSub/addOtherIncome`,
            {
              dateOtherIncome,
              descriptionOtherIncome,
              amountOtherIncome,
              id,
            },
          );

          if (response.status === 200) {
            swal({
              icon: "success",
              title: "Transaction created successfully",
              timer: 2000,
            }).then(() => {
              handleClose();
              reloadTable();
              reloadAccountName();
              Balance();
            });
          } else {
            swal({
              icon: "error",
              title: "Something went wrong",
              text: "Please contact your support immediately",
              timer: 2000,
            });
          }
        }
      } catch (error) {
        console.error(error);
        swal({
          icon: "error",
          title: "Something went wrong",
          text: "Please contact your support immediately",
          timer: 2000,
        });
      }
    }
  };

  const handleAmountChange = (value) => {
    if (value == ".") {
      setAmount((prev) => prev + ".");
    }

    let inputValue = String(value).replace(/[^0-9.]/g, "");

    let [integerPart, decimalPart] = inputValue.split(".");

    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    let formatAmount = inputValue.replace(/,/g, "");
    // Convert to number and format with commas
    let numericValue = parseFloat(formatAmount);

    const roundedStoredBalance =
      Math.round(parseFloat(accountName?.amount || 0) * 100) / 100;

    if (roundedStoredBalance < numericValue) {
      swal({
        icon: "error",
        title: `Insufficient Balance`,
        text: "The amount you are trying to withdraw is greater than the available balance.",
      }).then(() => {
        setAmount("0");
      });
    } else {
      setAmount(formattedValue);
    }
  };

  const handleCalculateConversion = (rate, amount) => {
    if (accountName?.currency?.currency_name === "PHP") {
      return amount / rate;
    } else {
      return amount * rate;
    }
  };

  const handlePaymentMethod = (e) => {
    const paymentMethod = e.target.value;
    setSelectedPaymentPay(paymentMethod);
    setSubject1("");
    setSubject2("");
    setSubject3("");
  };

  // Currency Options for dropdown select
  // const currencyOptions = currencyList
  //   .filter((option) => option.id !== accountName?.currency?.id)
  //   .map((item) => ({
  //     value: item.id,
  //     label: item.currency_name,
  //   }));

  const currencyOptions =
    accountName?.currency?.currency_name !== "PHP"
      ? [
          {
            value: "11111111-1111-1111-1111-111111111111",
            label: "PHP",
          },
        ]
      : currencyList
          .filter((option) => option.id !== accountName?.currency?.id)
          .map((item) => ({
            value: item.id,
            label: item.currency_name,
          }));

  // Get available options based on subject type or module type
  const subject1AvailableOptions = (subjectType) => {
    const options = {
      "Account-List": ["Account-List", "Asset Account"],
      "Asset Account": ["Account-List", "Asset Account"],
      defaultOption: [
        "Account-List",
        "Asset Account",
        "Owner's Equity Account",
      ],
    };

    return options[subjectType] ?? options.defaultOption;
  };

  // Subject 1 Options for dropdown select
  const subject1Options = (subjectType) => {
    const isOwnersEquity = subjectType === "Owner's Equity Account";
    const availableOptions = subject1AvailableOptions(subjectType);

    return availableOptions.map((item) => ({
      value: item,
      label: item,
      ...(isOwnersEquity && item !== "Account-List" && { isDisabled: true }),
    }));
  };

  // Subject 2 Options for dropdown select
  const subject2Options = subject2DataList?.map((item) => {
    return {
      value: item.id,
      label: item.subject_name,
      subject_type: item.subject_type,
    };
  });

  // Subject 3 Options for dropdown select
  const subject3Options = subject3DataList
    .filter(
      (option) =>
        otherCurrency || option.currency.id === accountName?.currency?.id,
    )
    .map((item) => {
      return {
        value: item.id,
        label: item.account_name,
        amount: item.amount,
      };
    });

  // Payment method options for dropdown select
  const paymentMethodOptions = ["Cash", "Bank", "Online"].map((item) => ({
    value: item,
    label: item,
  }));

  // "Cash" as default value for payment method
  const paymentMethodDefaultValue = paymentMethodOptions.find(
    (item) => item.value === "Cash",
  );

  // Custom input for DatePicker: typed as MM/dd/yyyy and shown as Oct/10/2026
  // (TypedDateInput). Only a complete date reaches handleDateChange, so the
  // cutoff checks (Process / Maturity / Pay Date) don't run on a half-typed date.
  const CustomInput = useMemo(() => {
    const Input = forwardRef(
      (
        {
          value,
          onClick,
          onChange,
          onBlur,
          onFocus,
          onKeyDown,
          disabled,
          generateYears,
        },
        ref,
      ) => {
        return (
          <TypedDateInput
            className="form-control p-2 w-100"
            style={{ cursor: disabled ? "not-allowed" : "text" }}
            onClick={(e) => {
              if (disabled) return; // Prevent clicking when disabled
              if (onClick) onClick(e);

              let dateYear = new Date().getFullYear();
              if (value) {
                const parsed = new Date(value);
                if (!isNaN(parsed.getTime())) {
                  dateYear = parsed.getFullYear();
                }
              }

              if (generateYears && typeof generateYears === "function") {
                generateYears(dateYear); // Reset/Initialize Year List based on selected date
              }
            }}
            onChange={onChange}
            onBlur={onBlur}
            onFocus={onFocus}
            onKeyDown={onKeyDown}
            value={value}
            ref={ref}
            required
            disabled={disabled}
          />
        );
      },
    );

    Input.displayName = "CustomInput";
    return Input;
  }, []);

  const { isSortedAsc, sortColumn, toggleSort } = useSort(
    "name",
    false,
    pagination.dynamicApiUrl,
  );

  const handleSortData = (column) => {
    toggleSort(column, (params) => {
      pagination.updateParams({
        sortType: params.sortType,
        sortDBTableColumn: params.sortDBTableColumn,
        id: id,
      });
    });
  };

  console.log(`pagination.data`, pagination.data);

  console.log(receivedCurrencyRate);

  const handleViewAction = (row) => {
    setSelectedTransactionId(row.id);
    setShowViewModal(true);
  };

  const handleRowClick = (row) => {
    handleViewAction(row);
  };

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      <div className="w-100 p-2 d-flex flex-row justify-content-between">
        <div className="d-flex flex-column title-custom">
          <span className="fs-3">
            {" "}
            <Link
              to={
                module_type === "Account-List"
                  ? `/accounts/account-list1?subject2=${searchParams.get(
                      "subject2",
                    )}&items-shown=${searchParams.get("items-shown")}`
                  : module_type === "Owner's Equity Account"
                    ? `/accounting/equity?subject2=${searchParams.get(
                        "subject2",
                      )}&items-shown=${searchParams.get("items-shown")}`
                    : module_type === "Liabilities Account"
                      ? `/accounting/liabilities1?subject2=${searchParams.get(
                          "subject2",
                        )}&items-shown=${searchParams.get("items-shown")}`
                      : `/accounting/assetaccount-list1?subject2=${searchParams.get(
                          "subject2",
                        )}&items-shown=${searchParams.get("items-shown")}`
              }
              className="text-dark mx-2"
            >
              <i class="fa-solid fa-arrow-left"></i>
            </Link>
            View Account
          </span>
        </div>
        {/* Export: opens a preview first, download is below the preview.
            Shown only with the "Account Report" RBAC permission */}
        {authrztn.includes("AccountReport-View") && (
        <div className="btn-group align-self-center">
          <button
            type="button"
            className="btn btn-success dropdown-toggle px-3"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            <i className="fa-solid fa-file-export me-2"></i>
            Export
          </button>
          <ul className="dropdown-menu dropdown-menu-end">
            <li>
              <button
                type="button"
                className="dropdown-item"
                onClick={() => setExportType("pdf")}
              >
                <i className="fa-solid fa-file-pdf me-2 text-danger"></i>
                PDF
              </button>
            </li>
            <li>
              <button
                type="button"
                className="dropdown-item"
                onClick={() => setExportType("excel")}
              >
                <i className="fa-solid fa-file-excel me-2 text-success"></i>
                Excel
              </button>
            </li>
          </ul>
        </div>
        )}
        {/* <div className="d-flex flex-row align-items-center row">
          <div className="col-sm">
            <span className="">Account Currency</span>
          </div>
          <div className="col-sm-8">
            <select name="" id="" className="form-select p-2">
              <option value="" selected disabled>
                Select Currency
              </option>
            </select>
          </div>
        </div> */}
      </div>
      <div className="container-fluid mt-3">
        <div className="row">
          <div className="col-12 col-md-4">
            <div className="w-100 h-100 border shadow-sm rounded p-2">
              <h5>Account Details</h5>
              <div
                className="card p-2 mt-2 text-start shadow-sm"
                style={{ height: "8rem" }}
              >
                <span>
                  <strong>Account Name:</strong>{" "}
                  <span>{accountName.account_name} </span>
                </span>
                <span className="mt-2 mb-2" style={{ fontWeight: 500 }}>
                  <strong>Account Type:</strong>{" "}
                  <span>
                    {accountName?.account_list_base_sub?.subject_type}{" "}
                  </span>
                </span>
                <span className="mt-2 mb-2" style={{ fontWeight: 500 }}>
                  <strong>Currency:</strong>{" "}
                  <span>{accountName?.currency?.currency_name} </span>
                </span>
              </div>
              <br />
              <h5>Account Balance</h5>

              <div
                className="card p-2 mt-2 shadow-sm d-flex align-items-center justify-content-center"
                style={{ height: "8rem" }}
              >
                <div className="d-flex flex-column align-items-center">
                  <span
                    className="account-balance-amount"
                    style={{
                      fontWeight: 500,
                      fontSize: "2rem",
                    }}
                  >
                    {formatCurrency(
                      accountName.amount,
                      accountName?.currency?.currency_name,
                    )}
                  </span>

                  {userLoggedID === "11111111-1111-1111-1111-111111111111" && (
                    <JournalizedBalance
                      AccountTransactedID={id}
                      BASE_URL={BASE_URL}
                      currency_name={
                        accountName?.currency?.currency_name || "PHP"
                      }
                    />
                  )}
                </div>
              </div>
              <br />
              {accountName?.account_list_base_sub?.module_type !==
              "Liabilities Account" ? (
                <div
                  className="card p-2 mt-2 text-start shadow-sm"
                  style={{ height: "8rem" }}
                >
                  <div className="w-100 h-100 d-flex flex-column justify-content-around align-items-center">
                    {/* {accountName?.account_list_base_sub?.module_type ===
                    "Owner's Equity Account" && (
                    <button
                      className="btn btn-outline-success px-5 w-75"
                      onClick={handleShow}
                    >
                      <i className="fas fa-plus"></i> Other Income
                    </button>
                  )} */}

                    <button
                      className="btn btn-warning px-5 w-75"
                      onClick={() => handleShow2("Normal")}
                    >
                      <i className="fas fa-paper-plane"></i> Transfer Money
                    </button>

                    {fromAccList ? (
                      <>
                        <button
                          className="btn btn-warning px-5 w-75"
                          onClick={() => handleShow2("Other")}
                        >
                          <i className="fas fa-paper-plane"></i> Transfer Money
                          to Other Currency
                        </button>
                      </>
                    ) : null}
                  </div>
                </div>
              ) : (
                <>
                  <div className="d-flex flex-column justify-content-around align-items-center">
                    <button
                      className="btn btn-warning w-75"
                      onClick={handleShowPayModal}
                    >
                      <i className="fas fa-paper-plane"></i> PAY
                    </button>
                  </div>
                </>
              )}

              <br />
            </div>
          </div>
          <div className="col-12 col-md-8">
            <div className="balance-chart w-100">
              <Card>
                <Card.Body>
                  <Card.Title> Balance </Card.Title>
                  <Line options={chartOptions} data={chartData} />
                </Card.Body>
              </Card>
            </div>
          </div>
        </div>
      </div>
      <div className="w-100 d-flex align-items-center my-4">
        <span>Transaction History</span>
        <hr className="flex-grow-1 mx-3" />
      </div>

      <div className="w-100">
        <div className="row">
          <div className="col-sm">
            <div className="row">
              <div className="col-sm mb-2">
                <span>From</span>
                {/* <input
                  type="date"
                  className="form-control p-2"
                  value={fromDate}
                  onChange={(e) => setFromDate(e.target.value)}
                /> */}
                {/* <div className="position-relative">
                  <DatePicker
                    selected={fromDate}
                    dateFormat="MMM/dd/yyyy"
                    onChange={(date) => {
                      setFromDate(date);
                    }}
                    className="form-control p-2"
                    customInput={<CustomInput />}
                  />
                  <i
                    class="fa-solid fa-calendar-week calendar-position"
                    style={{
                      right: "1rem",
                      top: "0.8rem",
                    }}
                  ></i>
                </div> */}
                <CustomDatePicker
                  selected={fromDate ? new Date(fromDate) : ""}
                  handleDateChange={(date) => {
                    setFromDate(date);
                  }}
                  setter={setFromDate}
                  CustomInput={CustomInput}
                />
              </div>
              <div className="col-sm mb-2">
                <span>To</span>
                {/* <input
                  type="date"
                  className="form-control p-2"
                  value={toDate}
                  onChange={(e) => setToDate(e.target.value)}
                /> */}
                {/* <div className="position-relative">
                  <DatePicker
                    selected={toDate}
                    dateFormat="MMM/dd/yyyy"
                    onChange={(date) => {
                      setToDate(date);
                    }}
                    className="form-control p-2"
                    customInput={<CustomInput />}
                  />
                  <i
                    class="fa-solid fa-calendar-week calendar-position"
                    style={{
                      right: "1rem",
                      top: "0.8rem",
                    }}
                  ></i>
                </div> */}
                <CustomDatePicker
                  selected={toDate ? new Date(toDate) : ""}
                  handleDateChange={(date) => {
                    setToDate(date);
                  }}
                  setter={setToDate}
                  CustomInput={CustomInput}
                />
              </div>
            </div>
          </div>
          <div className="col-sm d-flex flex-row align-items-end mb-2 filter-btn-container">
            <button className="btn w-100" onClick={applyFilter}>
              Apply Filter
            </button>
            <button className="btn btn-secondary w-100" onClick={clearFilter}>
              Clear Filter
            </button>
          </div>
          <div className="col-sm"></div>
        </div>
        <div className="w-100 overflow-y-scroll" style={{ maxHeight: "90vh" }}>
          <Table
            bordered
            hover
            responsive
            className="align-middle"
            style={{ borderColor: "black" }}
          >
            <thead>
              <tr>
                <th
                  className="p-3 align-middle text-start cursor-pointer"
                  rowSpan="2"
                  onClick={() => handleSortData("createdAt")}
                  title="Sort by Date"
                >
                  <div className="d-flex flex-row p-0 align-items-center justify-content-between">
                    Date
                    <span className="d-flex flex-column mx-2">
                      <i
                        className="fa-solid fa-chevron-up"
                        style={{
                          fontSize: 10,
                          opacity:
                            sortColumn === "createdAt" && !isSortedAsc
                              ? 1
                              : 0.3,
                        }}
                      />
                      <i
                        className="fa-solid fa-chevron-down"
                        style={{
                          fontSize: 10,
                          opacity:
                            sortColumn === "createdAt" && isSortedAsc ? 1 : 0.3,
                        }}
                      />
                    </span>
                  </div>
                </th>

                {/* Withdraw section */}
                <th className="text-center p-0" colSpan="4">
                  <div className="p-3 fw-bold text-danger border-bottom">
                    Withdraw
                  </div>
                </th>

                {/* Deposit section */}
                <th className="text-center p-0" colSpan="4">
                  <div className="p-3 fw-bold text-success border-bottom">
                    Deposit
                  </div>
                </th>

                <th className="p-3 text-center align-middle" rowSpan="2">
                  Last Balance
                </th>
              </tr>
              <tr className="bg-light">
                {/* Withdraw columns */}
                <th
                  className="p-3 text-start fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  Payment Method
                </th>
                <th
                  className="p-3 text-start fw-medium"
                  style={{ fontSize: "0.9rem", minWidth: "150px" }}
                >
                  To
                </th>
                <th
                  className="p-3 text-start fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  Check No.
                </th>
                <th
                  className="p-3 text-end fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  Amount
                </th>

                {/* Deposit columns */}
                <th
                  className="p-3 text-start fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  Payment Method
                </th>
                <th
                  className="p-3 text-start fw-medium"
                  style={{ fontSize: "0.9rem", minWidth: "150px" }}
                >
                  From
                </th>
                <th
                  className="p-3 text-start fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  Check No.
                </th>
                <th
                  className="p-3 text-end fw-medium"
                  style={{ fontSize: "0.9rem" }}
                >
                  Amount
                </th>
              </tr>
            </thead>

            <tbody>
              {filteredTransactions.length === 0 ? (
                <tr>
                  <td colSpan="10" className="text-center py-5 text-muted">
                    No transactions found.
                  </td>
                </tr>
              ) : (
                filteredTransactions.map((transaction, index) => (
                  <tr
                    key={index}
                    onClick={() => handleRowClick(transaction)}
                    title="Click to view full transaction details"
                    className="transaction-row-hover cursor-pointer"
                  >
                    {/* Date column */}
                    <td className="p-3 align-middle">
                      <div className="fw-medium d-flex flex-column gap-1">
                        <span className="text-dark">
                          {transaction.createdAt
                            ? format(
                                new Date(transaction.createdAt),
                                "MMM dd, yyyy",
                              )
                            : "---"}
                        </span>
                        <span style={{ fontSize: "0.85em", opacity: 0.7 }}>
                          Transaction Date:{" "}
                          {transaction.date
                            ? format(new Date(transaction.date), "MMM dd, yyyy")
                            : "---"}
                        </span>

                        {/* VIEW MORE INDICATOR */}
                        <span
                          className="text-primary mt-1"
                          style={{ fontSize: "0.75rem", fontWeight: "600" }}
                        >
                          <i className="fa-solid fa-magnifying-glass-plus me-1"></i>
                          View Info
                        </span>
                      </div>
                    </td>

                    {/* Withdraw section (Credit) */}
                    <td className="p-3 align-middle">
                      {transaction.type === "Credit" ? (
                        <span className="badge bg-light text-dark border">
                          {transaction.payment_method || "---"}
                        </span>
                      ) : (
                        "---"
                      )}
                    </td>

                    <td
                      className="p-3 align-middle"
                      style={{ minWidth: "150px" }}
                    >
                      {transaction.type === "Credit"
                        ? transaction.sub3_tos?.account_name ||
                          transaction?.transacted
                        : "---"}
                    </td>

                    <td className="p-3 align-middle">
                      {transaction.type === "Credit"
                        ? transaction.check_or_remarks || "---"
                        : "---"}
                    </td>

                    <td className="p-3 text-end align-middle fw-medium">
                      {transaction.type === "Credit" ? (
                        <span className="text-danger">
                          {formatToTwoDecimal(transaction.amount)}
                        </span>
                      ) : (
                        "---"
                      )}
                    </td>

                    {/* Deposit section (Debit) */}
                    <td className="p-3 align-middle">
                      {transaction.type === "Debit" ? (
                        <span className="badge bg-light text-dark border">
                          {transaction.payment_method || "---"}
                        </span>
                      ) : (
                        "---"
                      )}
                    </td>

                    <td
                      className="p-3 align-middle"
                      style={{ minWidth: "150px" }}
                    >
                      {transaction.type === "Debit"
                        ? transaction?.transacted ||
                          transaction.sub3_tos?.account_name
                        : "---"}
                    </td>

                    <td className="p-3 align-middle">
                      {transaction.type === "Debit"
                        ? transaction.check_or_remarks || "---"
                        : "---"}
                    </td>

                    <td className="p-3 text-end align-middle fw-medium">
                      {transaction.type === "Debit" ? (
                        <span className="text-success">
                          {formatToTwoDecimal(transaction.amount)}
                        </span>
                      ) : (
                        "---"
                      )}
                    </td>

                    {/* Balance column */}
                    <td className="p-3 text-end align-middle fw-bold">
                      <div className="bg-light p-2 rounded border-bottom">
                        {transaction.type === "Debit" ? (
                          <span>
                            {formatToTwoDecimal(transaction.account_balance)}
                          </span>
                        ) : transaction.type === "Credit" ? (
                          <span>
                            {formatToTwoDecimal(transaction.account_balance)}
                          </span>
                        ) : (
                          "---"
                        )}
                      </div>
                    </td>
                  </tr>
                ))
              )}
            </tbody>
          </Table>
        </div>

        <PaginationControls {...pagination} />
      </div>

      {/* In */}

      <Modal show={showModal} onHide={handleClose} backdrop="static" size="md">
        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => handleOtherIncomeSubmit(e)}
        >
          <Modal.Header className="border-0">
            <Modal.Title>Other Income</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="w-100">
              <div className="row">
                <div className="col-sm">
                  <span>Date</span>
                  <input
                    type="date"
                    required
                    className="form-control"
                    onChange={(e) => setDateOtherIncome(e.target.value)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm">
                  <span>Description: </span>
                  <textarea
                    type="text"
                    required
                    className="form-control "
                    onChange={(e) => setDescriptionOtherIncome(e.target.value)}
                  />
                </div>
              </div>

              <div className="row">
                <div className="col-sm">
                  <span>Amount: </span>
                  <input
                    type="text"
                    className="form-control "
                    required
                    onInput={onInputFloat}
                    onChange={(e) => setAmountOtherIncome(e.target.value)}
                  />
                </div>
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="button"
              variant="outline-secondary"
              onClick={handleClose}
            >
              Close
            </Button>
            <Button variant="primary" type="submit">
              Submit
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
      {/* Out */}

      {/* transfer amount other currency */}
      <Modal
        show={showModal2}
        onHide={() => !isTransferSubmitting && handleClose()}
        backdrop="static"
        size="md"
      >
        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => handleFormSubmit(e, "Credit")}
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-primary">
              <strong>Payment Confirmation (Credit)</strong>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid">
              {/* Bank / Cash radio buttons — always shown in Transfer Money modal */}
              <Form.Group className="mb-3" controlId="transferPayWith">
                <Form.Label className="fw-bold">
                  Pay With: <span className="text-danger">*</span>
                </Form.Label>
                <div className="d-flex gap-3">
                  <Form.Check
                    type="radio"
                    name="transferPaymentType"
                    id="transfer-bank"
                    label="Bank"
                    value="Bank"
                    checked={transferPaymentMethod === "Bank"}
                    onChange={(e) => {
                      setTransferPaymentMethod(e.target.value);
                      setMaturityCheckNo("");
                      // Reset subjects so stale selections are cleared
                      setSubject1("");
                      setSubject2("");
                      setSubject3("");
                      setSubject2DataList([]);
                      setSubject3DataList([]);
                      setIsSubject2Disabled(true);
                      setIsSubject3Disabled(true);
                      setIsPaymentMethodDisabled(true);
                      setIsRemarksDisabled(true);
                    }}
                  />
                  <Form.Check
                    type="radio"
                    name="transferPaymentType"
                    id="transfer-cash"
                    label="Cash"
                    value="Cash"
                    checked={transferPaymentMethod === "Cash"}
                    onChange={(e) => {
                      setTransferPaymentMethod(e.target.value);
                      setMaturityCheckNo("");
                      // Reset subjects so stale selections are cleared
                      setSubject1("");
                      setSubject2("");
                      setSubject3("");
                      setSubject2DataList([]);
                      setSubject3DataList([]);
                      setIsSubject2Disabled(true);
                      setIsSubject3Disabled(true);
                      setIsPaymentMethodDisabled(true);
                      setIsRemarksDisabled(true);
                      // Only clear the maturity date state (hidden for Cash).
                      // creditDateError stays — it belongs to Process Date which
                      // is shared across payment methods and must keep blocking submit.
                      setDate("");
                    }}
                  />
                </div>
                <small className="text-muted">
                  {transferPaymentMethod === "Bank" && checkNo
                    ? "Balance will be deducted from sender immediately. Receiver is credited when the check is collected in Receivable Checks."
                    : transferPaymentMethod === "Bank"
                      ? "Balance will NOT be deducted immediately — will appear in Receivable Check (Pending) for Collect & Confirm."
                      : transferPaymentMethod === "Cash"
                        ? "Balance will NOT be deducted immediately — will appear in Receivable Check (Pending) for Collect & Confirm."
                        : ""}
                </small>
              </Form.Group>

              {otherCurrency ? (
                <>
                  <div className="mb-3">
                    <label htmlFor="amount" className="fw-semibold">
                      Currency
                    </label>
                    <Select
                      options={currencyOptions}
                      value={selectedCurrency}
                      onChange={handleCurrencyChange}
                      placeholder={`Select Currency`}
                      styles={dmSelectStyles(selectedCurrency, validated)}
                      required
                      isSearchable
                    />
                  </div>
                </>
              ) : null}

              <div className="mb-3">
                <label htmlFor="subject1" className="fw-semibold">
                  Step 1 / Subject <span className="text-danger">*</span>
                </label>
                {/* <select
                  className="form-select"
                  onChange={handleSubject1Change}
                  value={subject1}
                  required
                  disabled={isSubject1Disabled && otherCurrency}
                >
                  <option value="" selected disabled>
                    Select Account
                  </option>
                  <option value="Account-List">Account-List</option>
                  <option value="Asset Account">Asset Account</option>
                  <option value="Liabilities Account">
                    Liabilities Account
                  </option>
                  <option value="Owner's Equity Account">
                    Owner's Equity Account
                  </option>
                </select> */}
                <Select
                  options={subject1Options(module_type)}
                  value={subject1}
                  onChange={handleSubject1Change}
                  isDisabled={isSubject1Disabled && otherCurrency}
                  placeholder={`Select Subject 1`}
                  styles={dmSelectStyles(subject1, validated)}
                  required
                  isSearchable
                />
              </div>

              <div className="mb-3 is-invalid">
                <label htmlFor="subject2" className="fw-semibold">
                  Step 2 / Subject <span className="text-danger">*</span>
                </label>
                {/* <select
                  className="form-select"
                  onChange={(e) =>
                    handleSubject2Change(
                      e,
                      e.target.options[e.target.selectedIndex].getAttribute(
                        "data-subject-type"
                      )
                    )
                  }
                  value={subject2}
                  disabled={isSubject2Disabled}
                  required
                >
                  <option value="" selected disabled>
                    Select Subject 2
                  </option>
                  {subject2DataList.map((option) => (
                    <option
                      key={option.id}
                      value={option.id}
                      data-subject-type={option.subject_type}
                    >
                      {option.subject_name}
                    </option>
                  ))}
                </select> */}
                <Select
                  options={subject2Options}
                  value={subject2}
                  onChange={handleSubject2Change}
                  isDisabled={isSubject2Disabled}
                  placeholder={`Select Subject 2`}
                  styles={dmSelectStyles(subject2, validated)}
                  required
                  isSearchable
                />
              </div>

              <div className="mb-3">
                <label htmlFor="subject3" className="fw-semibold">
                  Step 3 / Subject <span className="text-danger">*</span>
                </label>
                {/* <select
                  className="form-select"
                  onChange={handleSubject3Change}
                  value={subject3}
                  disabled={isSubject3Disabled}
                  required
                >
                  <option value="" selected disabled>
                    Select Subject 3
                  </option>
                  {subject3DataList
                    .filter(
                      (option) =>
                        otherCurrency ||
                        option.currency.id === accountName?.currency?.id
                    )
                    .map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.account_name}
                      </option>
                    ))}
                </select> */}
                <Select
                  options={subject3Options}
                  value={subject3}
                  onChange={handleSubject3Change}
                  isDisabled={isSubject3Disabled}
                  placeholder={`Select Subject 3`}
                  styles={dmSelectStyles(subject3, validated)}
                  required
                  isSearchable
                />
              </div>

              {/*ask bat naka hide ito*/}
              <div className="mb-3 d-none">
                <label htmlFor="payment-method" className="fw-semibold">
                  Payment Method
                </label>
                {/* <select
                  className="form-select"
                  onChange={handlePaymentMethodChange}
                  value={paymentMethod}
                  disabled={isPaymentMethodDisabled}
                  required
                >
                  <option value="" selected disabled>
                    Select Payment Method
                  </option>
                  {subject2Type === "Cash" ? (
                    <option value="Cash">Cash</option>
                  ) : (
                    <option value="Bank">Bank</option>
                  )}
                  <option value="Cash">Cash</option>
                  <option value="Bank">Bank</option>

                  <option value="Online">Online</option>
                </select> */}
                <Select
                  options={paymentMethodOptions}
                  defaultValue={paymentMethodDefaultValue}
                  value={paymentMethod}
                  onChange={handlePaymentMethodChange}
                  isDisabled={isPaymentMethodDisabled}
                  placeholder={`Select Payment Method`}
                  styles={dmSelectStyles(paymentMethod, validated)}
                  required
                  isSearchable
                />
              </div>

              {/* Check Number */}
              {transferPaymentMethod === "Bank" && (
                <div>
                  <Form.Label htmlFor="checkNo" className="fw-semibold mb-0">
                    Check No.
                  </Form.Label>
                  <Form.Control
                    type="text"
                    id="checkNo"
                    value={checkNo}
                    disabled={!subject3}
                    onChange={(e) => setCheckNo(e.target.value)}
                  />
                  <CheckNumberError value={checkNo} />
                </div>
              )}

              {/* Bank: no check number input — inform the user the transfer will be pending */}
              {transferPaymentMethod === "Bank" && fromAccList && (
                <small className="text-muted d-block mb-3">
                  This will be recorded as a pending receivable check.
                </small>
              )}

              <div className="mb-3">
                <Form.Label htmlFor="remarks" className="fw-semibold mb-0">
                  Remarks
                </Form.Label>
                <Form.Control
                  type="text"
                  id="remarks"
                  value={remarks}
                  disabled={!subject3}
                  onChange={(e) => setRemarks(e.target.value)}
                />
              </div>

              {/* Process Date */}
              <div className="mb-3">
                <label htmlFor="process-date" className="fw-semibold">
                  Process Date <span className="text-danger">*</span>
                </label>
                <CustomDatePicker
                  selected={processDate ? new Date(processDate) : ""}
                  maxDate={new Date()}
                  handleDateChange={async (selectedDate) => {
                    const previousProcessDate = processDate;
                    setProcessDate(selectedDate);
                    setCreditDateError("");
                    if (!selectedDate) return;

                    // Same cutoff warning as create_invoice.jsx (utils/cutoffDateValidation)
                    const cutoffStatus = await checkCutoffDate(
                      selectedDate,
                      "Process Date",
                    );

                    if (cutoffStatus === "posted") {
                      // Posted cutoff: keep the previous Process Date
                      setProcessDate(previousProcessDate);
                      return;
                    }

                    if (cutoffStatus === "missing") {
                      // Keep blocking submit until a date with a cutoff is chosen
                      setCreditDateError(
                        "The selected date does not fall within any cutoff period. Please choose a valid date.",
                      );
                      return;
                    }

                    if (!date) {
                      setDate(selectedDate);
                    }

                    if (date && new Date(selectedDate) >= new Date(date)) {
                      setDate("");
                    }

                    // Replaced by checkCutoffDate above
                    /* if (selectedDate) {
                      try {
                        const formattedDate = format(
                          new Date(selectedDate),
                          "yyyy-MM-dd",
                        );

                        const { data: isInCutoff } = await axios.get(
                          `${BASE_URL}/cutoff/dateValidation`,
                          { params: { date: formattedDate } },
                        );

                        if (!isInCutoff) {
                          setCreditDateError(
                            "The selected date does not fall within any cutoff period. Please choose a valid date.",
                          );
                          return;
                        }

                        const { data: isPosted } = await axios.get(
                          `${BASE_URL}/cutoff/validation/posted-cutoff`,
                          { params: { date: formattedDate } },
                        );

                        if (isPosted) {
                          setCreditDateError(
                            "The selected date falls within a posted cutoff period. Please choose a date in an unposted cutoff.",
                          );
                          return;
                        }

                        if (!date) {
                          setDate(selectedDate);
                        }

                        if (date && new Date(selectedDate) >= new Date(date)) {
                          setDate("");
                        }
                      } catch (err) {
                        console.error("Cutoff validation error:", err);
                      }
                    } */
                  }}
                  setter={setProcessDate}
                  validated={validated}
                  isRequired={true}
                  disabled={!subject3}
                  CustomInput={CustomInput}
                />
                {creditDateError && (
                  <div className="text-danger small mt-1">
                    <i className="fa-solid fa-circle-exclamation me-1"></i>
                    {creditDateError}
                  </div>
                )}
              </div>

              {/* Maturity Date — hidden for Cash */}
              {transferPaymentMethod !== "Cash" && (
                <div className="mb-3">
                  <label htmlFor="date" className="fw-semibold">
                    Maturity Date
                  </label>
                  <CustomDatePicker
                    selected={date ? new Date(date) : ""}
                    handleDateChange={async (selectedDate) => {
                      const previousDate = date;
                      setDate(selectedDate);
                      if (!selectedDate) return;

                      // Same cutoff warning as create_invoice.jsx (utils/cutoffDateValidation)
                      const cutoffStatus = await checkCutoffDate(
                        selectedDate,
                        "Maturity Date",
                      );

                      // Posted cutoff: keep the previous Maturity Date
                      if (cutoffStatus === "posted") setDate(previousDate);
                    }}
                    minDate={
                      processDate
                        ? new Date(new Date(processDate).getTime())
                        : undefined
                    }
                    setter={setDate}
                    validated={validated}
                    isRequired={false}
                    disabled={!subject3}
                    CustomInput={CustomInput}
                  />
                  {processDate && (
                    <small className="text-muted">
                      Must be on OR after{" "}
                      {format(new Date(processDate), "MMM dd, yyyy")}
                    </small>
                  )}
                </div>
              )}

              {!otherCurrency &&
                accountName?.currency?.currency_name !== "PHP" && (
                  <div className="col-sm mb-3">
                    <label htmlFor="amount" className="fw-semibold">
                      Rate<span className="text-danger">*</span>
                      <span className="text-muted small ms-1">
                        (rate during receiving)
                      </span>
                    </label>

                    <input
                      type="text"
                      className="form-control"
                      placeholder="0.00"
                      disabled={!subject3}
                      required
                      value={rate}
                      onInput={(e) => {
                        let val = e.target.value.replace(/[^0-9.]/g, "");
                        // allow only one decimal point
                        const parts = val.split(".");
                        if (parts.length > 2)
                          val = parts[0] + "." + parts.slice(1).join("");

                        // REMOVED the 2-decimal limit here!

                        // limit total length to 23 characters
                        if (val.length > 23) val = val.slice(0, 23);
                        e.target.value = val;
                      }}
                      onChange={(e) => setRate(e.target.value)}
                    />
                  </div>
                )}

              <div className="mb-3">
                <label htmlFor="amount" className="fw-semibold">
                  Sum Amount <span className="text-danger">*</span>
                  {otherCurrency ? (
                    <>(In {accountName.currency.currency_name})</>
                  ) : null}
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="0.00"
                  // disabled={isRemarksDisabled}
                  disabled={!subject3}
                  required
                  onInput={onInputFloat}
                  value={amount}
                  onChange={(e) => handleAmountChange(e.target.value)}
                />
              </div>

              {otherCurrency ? (
                <>
                  <div className="row">
                    {" "}
                    {/* currency rate nung pumasok ang pera  */}
                    {accountName?.currency?.currency_name !== "PHP" && (
                      <div className="col-sm mb-3">
                        <label htmlFor="amount" className="fw-semibold">
                          Received Rate
                        </label>
                        {/* <input
                          type="text"
                          className="form-control"
                          placeholder="0.00"
                          // disabled={isRemarksDisabled}
                          disabled={!subject3}
                          required
                          onInput={onInputFloat}
                          value={receivedCurrencyRate}
                          onChange={(e) =>
                            setReceivedCurrencyRate(e.target.value)
                          }
                        /> */}
                        <Select
                          options={receivedRateOptions}
                          value={receivedCurrencyRate}
                          onChange={(selectedOption) =>
                            setReceivedCurrencyRate(selectedOption)
                          }
                          isDisabled={!subject3}
                          placeholder={`Select Received Rate`}
                          styles={dmSelectStyles(
                            receivedCurrencyRate,
                            validated,
                          )}
                          required
                          isSearchable
                        />
                      </div>
                    )}
                    <div className="col-sm mb-3">
                      <label htmlFor="amount" className="fw-semibold">
                        {" "}
                        {/* currency rate sa pag convert  */}
                        Exchange Rate
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        placeholder="0.00"
                        // disabled={isRemarksDisabled}
                        // disabled={!subject3}
                        readOnly
                        required
                        onInput={onInputFloat}
                        value={currencyRate}
                        onChange={(e) => setCurrencyRate(e.target.value)}
                      />
                    </div>
                  </div>

                  <div className="w-100 d-flex align-items-center">
                    <span>Indicative Exchange Rate</span>
                    <hr className="flex-grow-1 mx-3" />
                  </div>
                  <div className="w-100 mb-2 p-2">
                    <div className="fs-5 fw-bold">
                      {accountName.currency.currency_name === "PHP"
                        ? "1"
                        : currencyRate}{" "}
                      {selectedCurrencyName} ={" "}
                      {accountName.currency.currency_name === "PHP"
                        ? currencyRate
                        : "1"}{" "}
                      {accountName.currency.currency_name}{" "}
                    </div>
                  </div>
                  <div className="w-100 d-flex align-items-center">
                    <span>Total Calculated Amount to Send</span>
                    <hr className="flex-grow-1 mx-3" />
                  </div>
                  <div className="w-100 mb-2 p-2">
                    <div className="fs-5 fw-bold">
                      {parseNumber(amount) > 0 ? (
                        <>
                          {formatToTwoDecimal(
                            handleCalculateConversion(
                              currencyRate,
                              parseNumber(amount),
                            ),
                          )}{" "}
                          {selectedCurrencyName}
                        </>
                      ) : (
                        <>0.00 {selectedCurrencyName}</>
                      )}
                    </div>
                  </div>
                </>
              ) : null}
            </div>

            {/* <Table bordered>
              <thead>
                <tr>
                  <th>Subject 1</th>
                  <th>Subject 2</th>
                  <th>Subject 3</th>
                  <th>Payment Method</th>
                  <th>{paymentMethod === "Bank" ? "Check No." : "Remarks"}</th>
                  <th>Date</th>
                  <th>Amount</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td style={{ padding: "15px" }}>
                    <select
                      className="form-select"
                      onChange={handleSubject1Change}
                      value={subject1}
                      required
                    >
                      <option value="" selected disabled>
                        Select Account
                      </option>
                      <option value="Account-List">Account-List</option>
                      <option value="Asset Account">Asset Account</option>
                      <option value="Liabilities Account">
                        Liabilities Account
                      </option>
                      <option value="Owner's Equity Account">
                        Owner's Equity Account
                      </option>
                    </select>
                  </td>
                  <td style={{ padding: "15px" }}>
                    <select
                      className="form-select"
                      onChange={(e) =>
                        handleSubject2Change(
                          e,
                          e.target.options[e.target.selectedIndex].getAttribute(
                            "data-subject-type"
                          )
                        )
                      }
                      value={subject2}
                      disabled={isSubject2Disabled}
                      required
                    >
                      <option value="" selected disabled>
                        Select Subject 2
                      </option>
                      {subject2DataList.map((option) => (
                        <option
                          key={option.id}
                          value={option.id}
                          data-subject-type={option.subject_type}
                        >
                          {option.subject_name}
                        </option>
                      ))}
                    </select>
                  </td>
                  <td style={{ padding: "15px" }}>
                    <select
                      className="form-select"
                      onChange={handleSubject3Change}
                      value={subject3}
                      disabled={isSubject3Disabled}
                      required
                    >
                      <option value="" selected disabled>
                        Select Subject 3
                      </option>
                      {subject3DataList
                        .filter(
                          (option) =>
                            option.currency.id === accountName?.currency?.id
                        )
                        .map((option) => (
                          <option key={option.id} value={option.id}>
                            {option.account_name}
                          </option>
                        ))}
                    </select>
                  </td>
                  <td style={{ padding: "15px" }}>
                    <select
                      className="form-select"
                      onChange={handlePaymentMethodChange}
                      value={paymentMethod}
                      disabled={isPaymentMethodDisabled}
                      required
                    >
                      <option value="" selected disabled>
                        Select Payment Method
                      </option>
                      {subject2Type === "Cash" ? (
                        <option value="Cash">Cash</option>
                      ) : (
                        <option value="Bank">Bank</option>
                      )}

                      <option value="Online">Online</option>
                    </select>
                  </td>
                  <td style={{ padding: "15px" }}>
                    <input
                      type="text"
                      className="form-control"
                      disabled={isRemarksDisabled}
                      onChange={(e) => setCheckNo(e.target.value)}
                    />
                  </td>
                  <td style={{ padding: "15px" }}>
                    <input
                      type="date"
                      className="form-control"
                      disabled={isRemarksDisabled}
                      required
                      onChange={(e) => setDate(e.target.value)}
                    />
                  </td>
                  Amount
                  <td style={{ padding: "15px" }}>
                    <input
                      type="text"
                      className="form-control"
                      placeholder="0.00"
                      disabled={isRemarksDisabled}
                      required
                      onInput={onInputFloat}
                      value={amount}
                      onChange={(e) => handleAmountChange(e.target.value)}
                    />
                  </td>
                </tr>
              </tbody>
            </Table> */}
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="button"
              variant="outline-secondary"
              onClick={handleClose}
              disabled={isTransferSubmitting}
            >
              Close
            </Button>
            <Button
              variant="primary"
              type="submit"
              disabled={isTransferSubmitting}
            >
              {isTransferSubmitting ? "Submitting..." : "Submit"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* For Pay Modal  */}
      <Modal
        show={payModal}
        onHide={() => !isPaySubmitting && handleClosePayModal()}
        backdrop="static"
        size="md"
      >
        <Form
          noValidate
          validated={validated}
          onSubmit={(e) => handlePayLiability(e)}
        >
          <Modal.Header closeButton>
            <Modal.Title className="text-primary">
              <strong>Payment Confirmation (Credit)</strong>
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="container-fluid">
              <Form.Group className="mb-3" controlId="payWith">
                <Form.Label className="fw-bold">Pay With:</Form.Label>
                <div className="d-flex">
                  <Form.Check
                    type="radio"
                    name="paymentType"
                    id="bank"
                    label="Bank"
                    value="Bank"
                    checked={selectedPaymentPay === "Bank"}
                    onChange={handlePaymentMethod}
                    className="me-3"
                  />
                  <Form.Check
                    type="radio"
                    name="paymentType"
                    id="cash"
                    label="Cash"
                    value="Cash"
                    checked={selectedPaymentPay === "Cash"}
                    onChange={handlePaymentMethod}
                    className="me-3"
                  />
                </div>
              </Form.Group>

              <div className="mb-3">
                <label htmlFor="subject1" className="fw-semibold">
                  Step 1 / Subject <span className="text-danger">*</span>
                </label>
                {/* <select
                  className="form-select"
                  onChange={handleSubject1Change}
                  value={subject1}
                  required
                  disabled={isSubject1Disabled && otherCurrency}
                >
                  <option value="" selected disabled>
                    Select Account
                  </option>
                  <option value="Account-List">Account-List</option>
                  <option value="Asset Account">Asset Account</option>
                  <option value="Liabilities Account">
                    Liabilities Account
                  </option>
                  <option value="Owner's Equity Account">
                    Owner's Equity Account
                  </option>
                </select> */}
                <Select
                  options={subject1Options(module_type)}
                  value={subject1}
                  onChange={handleSubject1Change}
                  isDisabled={isSubject1Disabled && otherCurrency}
                  placeholder={`Select Subject 1`}
                  styles={dmSelectStyles(subject1, validated)}
                  required
                  isSearchable
                />
              </div>

              <div className="mb-3">
                <label htmlFor="subject2" className="fw-semibold">
                  Step 2 / Subject <span className="text-danger">*</span>
                </label>
                {/* <select
                  className="form-select"
                  onChange={(e) =>
                    handleSubject2Change(
                      e,
                      e.target.options[e.target.selectedIndex].getAttribute(
                        "data-subject-type"
                      )
                    )
                  }
                  value={subject2}
                  disabled={isSubject2Disabled}
                  required
                >
                  <option value="" selected disabled>
                    Select Subject 2
                  </option>
                  {subject2DataList.map((option) => (
                    <option
                      key={option.id}
                      value={option.id}
                      data-subject-type={option.subject_type}
                    >
                      {option.subject_name}
                    </option>
                  ))}
                </select> */}
                <Select
                  options={subject2Options}
                  value={subject2}
                  onChange={handleSubject2Change}
                  isDisabled={isSubject2Disabled}
                  placeholder={`Select Subject 2`}
                  styles={dmSelectStyles(subject2, validated)}
                  required
                  isSearchable
                />
              </div>

              <div className="mb-3">
                <label htmlFor="subject3" className="fw-semibold">
                  Step 3 / Subject <span className="text-danger">*</span>
                </label>
                {/* <select
                  className="form-select"
                  onChange={handleSubject3Change}
                  value={subject3}
                  disabled={isSubject3Disabled}
                  required
                >
                  <option value="" selected disabled>
                    Select Subject 3
                  </option>
                  {subject3DataList
                    .filter(
                      (option) =>
                        otherCurrency ||
                        option.currency.id === accountName?.currency?.id
                    )
                    .map((option) => (
                      <option key={option.id} value={option.id}>
                        {option.account_name}
                      </option>
                    ))}
                </select> */}
                <Select
                  options={subject3Options}
                  value={subject3}
                  onChange={handleSubject3Change}
                  isDisabled={isSubject3Disabled}
                  placeholder={`Select Subject 3`}
                  styles={dmSelectStyles(subject3, validated)}
                  required
                  isSearchable
                />
              </div>

              {/* <div className="mb-3">
                <label htmlFor="payment-method" className="fw-semibold">
                  Payment Method
                </label>
                <select
                  className="form-select"
                  onChange={handlePaymentMethodChange}
                  value={paymentMethod}
                  disabled={isPaymentMethodDisabled}
                  required
                >
                  <option value="" selected disabled>
                    Select Payment Method
                  </option>
                  {subject2Type === "Cash" ? (
                    <option value="Cash">Cash</option>
                  ) : (gfvvvvvvv 
                    <option value="Bank">Bank</option>
                  )}

                  <option value="Online">Online</option>
                </select>
              </div> */}

              {/* Bank: no check number input — inform the user the transfer will be pending */}
              {selectedPaymentPay === "Bank" && fromAccList && (
                <small className="text-muted d-block mb-3">
                  This will be recorded as a pending receivable check.
                </small>
              )}
              {/* Cash: no check number — direct transfer, balance deducted immediately */}

              <div className="mb-3">
                <label htmlFor="date" className="fw-semibold">
                  Date <span className="text-danger">*</span>
                </label>
                {/* <input
                  type="date"
                  className="form-control"
                  disabled={isRemarksDisabled}
                  required
                  onChange={(e) => setDate(e.target.value)}
                /> */}
                {/* <div className="position-relative">
                  <DatePicker
                    selected={date}
                    dateFormat="MMM/dd/yyyy"
                    onChange={(date) => {
                      setDate(date);
                    }}
                    className="form-control p-2"
                    customInput={
                      <CustomInput isRemarksDisabled={isRemarksDisabled} />
                    }
                  />
                  <i
                    class="fa-solid fa-calendar-week calendar-position"
                    style={{
                      right: `${
                        validated && !isRemarksDisabled ? "2rem" : "1rem"
                      }`,
                      top: "0.8rem",
                    }}
                  ></i>
                </div> */}
                <CustomDatePicker
                  selected={date ? new Date(date) : ""}
                  handleDateChange={async (selectedDate) => {
                    setDate(selectedDate);
                    setPayDateError("");
                    if (!selectedDate) return;
                    try {
                      setPayDateError(await getCutoffDateError(selectedDate));
                    } catch (err) {
                      console.error("Cutoff validation error:", err);
                    }
                  }}
                  setter={setDate}
                  validated={validated}
                  isRequired={true}
                  disabled={isRemarksDisabled}
                  CustomInput={CustomInput}
                />
                {payDateError && (
                  <div className="text-danger small mt-1">
                    <i className="fa-solid fa-circle-exclamation me-1"></i>
                    {payDateError}
                  </div>
                )}
              </div>

              <div className="mb-3">
                <label htmlFor="amount" className="fw-semibold">
                  Sum Amount <span className="text-danger">*</span>
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder="0.00"
                  disabled={isRemarksDisabled}
                  required
                  onInput={onInputFloat}
                  value={amount}
                  onChange={(e) => handleAmountChange(e.target.value)}
                />
              </div>
            </div>
          </Modal.Body>

          <Modal.Footer>
            <Button
              type="button"
              variant="outline-secondary"
              onClick={handleClosePayModal}
              disabled={isPaySubmitting}
            >
              Close
            </Button>
            <Button variant="primary" type="submit" disabled={isPaySubmitting}>
              {isPaySubmitting ? "Submitting..." : "Submit"}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      <AccountHistoryView
        show={showViewModal}
        onHide={() => setShowViewModal(false)}
        transactionId={selectedTransactionId}
      />

      {/* Asks for a date range first, then previews every transaction in it */}
      <AccountSummaryExportModal
        show={exportType !== null}
        type={exportType}
        onHide={() => setExportType(null)}
        accountId={id}
        accountName={accountName?.account_name}
        canDownload={authrztn.includes("AccountReport-IE")}
      />
    </div>
  );
};

export default ViewAccountlist1;
